import styled from "styled-components";

export const EffortlessWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 80px 0;
  color: #fff;
`;

export const EffortlessContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  max-width: 1200px;
  width: 95%;
  gap: 80px;
`;

export const EffortlessCards = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  width: 100%;
  @media screen and (max-width: 768px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  @media screen and (max-width: 479px) {
    display: grid;
    grid-template-columns: 1fr;
  }
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 40px;
  height: 400px;
  max-width: 260px;
  cursor: pointer;
  @media screen and (max-width: 768px) {
    max-width: 100%;
  }
  img {
    max-width: 180px;
    width: 100%;
    height: auto;
    @media screen and (max-width: 900px) {
      max-width: 140px;
    }
  }
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;

  span {
    text-align: center;
    line-height: 24px;
    color: rgba(255, 255, 255, 0.8);
  }
`;

export const CardHead = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: -8px;
  h4 {
    font-size: 32px;
    font-weight: 500;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  span {
    margin: 0;
    border: 1px solid rgba(225, 29, 72, 0.3);
    border-radius: 6px;
    margin-left: 6px;
    padding: 2px 8px;
    font-size: 12px;
    color: #e11d48;
    line-height: 14px;
  }
`;

export const EffortlessHead = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  @media screen and (max-width: 900px) {
    h1 {
      text-align: center;
      line-height: 48px;
    }
  }
`;
